var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/x-is-string/index.js
// module id = 317
// module chunks = 0 1 9 10